<template>
  <!-- image_url ? `${image_url}?dpr=2 2x, ${image_url}?dpr=3 3x` : placeholder -->
  <img
    :v-lazy="image_url"
    :srcset="image_url"
    :placeholder="placeholder"
    class="picture-component"
    alt="">
</template>
<script>
import placeholder from '../assets/images/placeholder.png';

export default {
  name: 'PictureComponent',
  props: {
    src: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      placeholder,
    };
  },
  computed: {
    image_url() {
      let a;
      if (!this.src) return this.placeholder;
      if (this.src.includes('https')) a = this.src;
      else if (this.src.includes('http')) a = this.src.replace('http', 'https');
      else if (!this.src.includes('https')) a = `https://${this.src}`;
      a += `?dpr=2 2x, ${a}?dpr=3 3x`;
      return a;
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss";
$colors: $brand, $purple, $blue, $green, $teal, $peach, $magenta;
$repeat: 20;
.picture-component {
  width: 100%;
  height: 100%;
  min-height: inherit;
  object-fit: cover;
  background-color: #eee;
}
// @for $i from 1 through $repeat {
//   .picture-component:nth-child(#{length($colors)}n+#{$i}) {
//       background-color: lighten(nth($colors, random(length($colors))), 20%);
//   }
// }
</style>



// WEBPACK FOOTER //
// app/src/components/PictureComponent.vue